module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-09-5458ef79e0587584365acca4fcf42ae8.png";